/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import Drawer from "@mui/material/Drawer";
import Hidden from "@mui/material/Hidden";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import clsx from "clsx";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import BASEPageSimpleSidebarContent from "./BASEPageSimpleSidebarContent";

const BASEPageSimpleSidebar = forwardRef((props, ref) => {
  const { open = true, position, variant, rootRef } = props;

  const [isOpen, setIsOpen] = useState(open);

  useImperativeHandle(ref, () => ({
    toggleSidebar: handleToggleDrawer,
  }));

  const handleToggleDrawer = useCallback((val) => {
    setIsOpen(val);
  }, []);

  useEffect(() => {
    handleToggleDrawer(open);
  }, [handleToggleDrawer, open]);

  return (
    <>
      <Hidden lgUp={variant === "permanent"}>
        <SwipeableDrawer
          variant="temporary"
          anchor={position}
          open={isOpen}
          onOpen={(ev) => {}}
          onClose={() => props?.onClose()}
          disableSwipeToOpen
          classes={{
            root: clsx("BASEPageSimple-sidebarWrapper", variant),
            paper: clsx(
              "BASEPageSimple-sidebar",
              variant,
              position === "left" ? "BASEPageSimple-leftSidebar" : "BASEPageSimple-rightSidebar",
              'max-w-full'
            ),
          }}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          // container={rootRef.current}
          BackdropProps={{
            classes: {
              root: "BASEPageSimple-backdrop",
            },
          }}
          style={{ position: "absolute" }}
        >
          <BASEPageSimpleSidebarContent {...props} />
        </SwipeableDrawer>
      </Hidden>

      {variant === "permanent" && (
        <Hidden lgDown>
          <Drawer
            variant="permanent"
            anchor={position}
            className={clsx(
              "BASEPageSimple-sidebarWrapper",
              variant,
              isOpen ? "opened" : "closed",
              position === "left"
                ? "BASEPageSimple-leftSidebar"
                : "BASEPageSimple-rightSidebar"
            )}
            open={isOpen}
            onClose={props?.onClose}
            classes={{
              paper: clsx("BASEPageSimple-sidebar border-0", variant),
            }}
          >
            <BASEPageSimpleSidebarContent {...props} />
          </Drawer>
        </Hidden>
      )}
    </>
  );
});

// BASEPageSimpleSidebar.defaultProps = {
//   open: true,
// };

export default BASEPageSimpleSidebar;
